import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import './print.scss'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const renderApplication = async () => {
    if (window.location.pathname === '/redirect') {
        // The ESLint resolver does not understand MSAL's package exports map.
        // eslint-disable-next-line import/no-unresolved
        const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge')
        await broadcastResponseToMainFrame()
        return
    }

    const { default: App } = await import('./App')
    root.render(
        <React.StrictMode>
            <div className='teste'>
                <App />
            </div>
        </React.StrictMode>
    )
}

renderApplication().catch(error => console.error('Application startup failed', error))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
